import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=6a02f026&"
import script from "./AdminOrders.vue?vue&type=script&lang=ts&"
export * from "./AdminOrders.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOrders.vue?vue&type=style&index=0&id=6a02f026&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports